module.exports = __webpack_public_path__ + "img/Jack sparrow-sample.1e17cc40.gif";